// DEVTOOLS
export const STORAGE_KEY_LIFE_DEV_TOOL_ACCESS_KEY = 'LIFE-DEV-TOOLS-ACCESS-KEY'
export const STORAGE_KEY_LIFE_DEV_TOOL_MOCK_ENABLED = 'LIFE-DEV-TOOLS-MOCK-ENABLED'


// SERVICE
export const STORAGE_KEY_LIFE_STORE_ACCESS_KEY = 'LIFE-STORE-ACCESS-KEY'
export const STORAGE_KEY_LIFE_STORE_MAIN_POPUP_SUPPRESSED = 'LIFE-STORE-MAIN-POPUP-SUPPRESSED'
export const STORAGE_KEY_LIFE_SCHEME_URL = 'LIFE-STORE-SCHEME-URL'
export const STORAGE_KEY_LIFE_UPDATE_OUTER_CAR_INFO = 'LIFE-STORE-UPDATE_OUTER-CAR-INFO'
export const STORAGE_KEY_LIFE_VEHICLE_MAINTENANCE_UPDATE_ITEMS = 'LIFE-STORE-VEHICLE_MAINTENANCE_UPDATE_ITEMS'
export const STORAGE_KEY_LIFE_EMERGENCY_CALL_CHECKED = 'LIFE-STORE-EMERGENCY-CALL-CHECKED'
export const STORAGE_KEY_LIFE_OPTIONAL_MARKETING_TERMS_STATUS = 'LIFE-STORE-OPTIONAL-MARKETING-TERMS-STATUS'
export const STORAGE_KEY_LIFE_DELETED_TRIP_SESSION_ID = 'LIFE-STORE-DELETED-TRIP-SESSION-ID'
export const STORAGE_KEY_LIFE_OTP_CLOSED = 'LIFE-STORE-OTP-CLOSED'
export const STORAGE_KEY_LIFE_VEHICLE_INSURANCE_INFO = 'LIFE_VEHICLE_INSURANCE_INFO'
export const STORAGE_KEY_LIFE_INSURANCE_SMART_BANNER_CLOSED_DATE = 'LIFE-STORE-INSURANCE-SMART-BANNER-CLOSED-DATE'
export const STORAGE_KEY_LIFE_INSURANCE_INTRO_POPUP_SUPPRESSED = 'LIFE-STORE-INSURANCE-INTRO-POPUP-SUPPRESSED'
export const STORAGE_KEY_LIFE_OPTIONAL_TERMS_SKIP_STATUS = 'LIFE-STORE-OPTIONAL-TERMS-SKIP-STATUS'
export const STORAGE_KEY_LIFE_INSURANCE_TOOLTIP_SHOWN = 'LIFE-STORE-INSURANCE-TOOLTIP-SHOWN'

// 리워드쇼핑
export const STORAGE_KEY_LIFE_REWARD_SHOPPING_TOKEN = 'LIFE-STORE-REWARD-SHOPPING-TOKEN'
